import { render, staticRenderFns } from "./DataNiaoSuan.vue?vue&type=template&id=9474c818&"
import script from "./DataNiaoSuan.vue?vue&type=script&lang=js&"
export * from "./DataNiaoSuan.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports